import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd947858")

_pushScopeId("data-v-fd947858")
const _hoisted_1 = { class: "tour-base-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "tour-base__table" }
const _hoisted_4 = { class: "table__wrap" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "tr table__row table__row--head" }
const _hoisted_7 = {
  key: 1,
  class: "table__no-data"
}
const _hoisted_8 = { class: "table__pagin" }
const _hoisted_9 = { class: "table__text" }
const _hoisted_10 = { class: "table__ctrl" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_SearcBlock = _resolveComponent("SearcBlock")
  const _component_SvgIcon = _resolveComponent("SvgIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumbs, { links: [{ to: 'tour-base', name: 'adaptiveTop.tourBase' }] }),
      _createVNode(_component_SectionTitle, {
        title: _ctx.$t('pages.tourBase.title'),
        class: "tour-base__title"
      }, null, 8, ["title"]),
      _createVNode(_component_SearcBlock, {
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.searchText = $event)),
        label: _ctx.$t('labels.searchTourControlers'),
        placeholder: _ctx.$t('labels.find'),
        class: "tour-base__search"
      }, null, 8, ["modelValue", "label", "placeholder"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeads, (th, thInd) => {
                return (_openBlock(), _createBlock("div", {
                  key: thInd,
                  style: th.style,
                  class: "th"
                }, _toDisplayString(_ctx.$t('pages.tourBase.table.' + th.name)), 5))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            (_ctx.getList.length)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.getList, (item, itemInd) => {
                  return (_openBlock(), _createBlock("div", {
                    key: _ctx.curPage + '' + itemInd,
                    class: "tr table__row"
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeads, (th, thInd) => {
                      return (_openBlock(), _createBlock("div", {
                        key: thInd,
                        style: _ctx.tableHeads[thInd].style,
                        class: "td"
                      }, _toDisplayString(th.name === 'order' ? item.id : _ctx.getFieldData(item, th.name)), 5))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('labels.noData')), 1))
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('labels.pageCounter', [_ctx.getCurPageCount(), _ctx.totalCount])), 1),
          _createVNode("div", _hoisted_10, [
            _createVNode("button", {
              class: ["table__btn table__btn--prev", { disabled: _ctx.curPage === 0 }],
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.clickPage(-1)))
            }, [
              _createVNode(_component_SvgIcon, { name: "arrowdown2" })
            ], 2),
            _createVNode("button", {
              class: ["table__btn table__btn--next", { disabled: _ctx.curPage >= _ctx.lastPage }],
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.clickPage(1)))
            }, [
              _createVNode(_component_SvgIcon, { name: "arrowdown2" })
            ], 2)
          ])
        ])
      ])
    ])
  ]))
})